import React from 'react';

import bridge from '@vkontakte/vk-bridge';
import { useSelector } from 'react-redux';

import { SharingPopout } from './SharingPopout';
import eventsApi from '../../../api/EventsApi';
import {
  getCareerGuidanceOptions,
  storyTemplate,
  USER_DENIED_ERROR_MESSAGE
} from '../../../constants/ResultData';
import { usePopout } from '../../../hooks/usePopout';
import { selectPopoutMetaInfo } from '../../../store/popoutSlice/popoutSelectors';
import { selectLocation } from '../../../store/routerSlice/routerSelectors';
import { CareerGuidanceType } from '../../../types/careerGuidance.type';
import { deepCopy } from '../../../utils/deepCopy';

const SharingPopoutContainer: React.FC = () => {
  const metaInfo = useSelector(selectPopoutMetaInfo);
  // @ts-ignore
  const temperamentType: CareerGuidanceType = metaInfo.temperamentType;
  // @ts-ignore
  const isOtherUserBeenPredicted: boolean = metaInfo.isOtherUserBeenPredicted;
  const location = useSelector(selectLocation);
  const temperamentData = getCareerGuidanceOptions()[temperamentType];
  const { resetPopout } = usePopout();

  const shareStory = async () => {
    resetPopout();

    const storyBoxToShow = deepCopy(storyTemplate.story_box);
    storyBoxToShow.url = isOtherUserBeenPredicted ? temperamentData.storyImage.other : temperamentData.storyImage.me;

    await bridge.send('VKWebAppShowStoryBox', storyBoxToShow)
      .then((data) => {
        const event = isOtherUserBeenPredicted ? storyTemplate.successfulOtherEvent : storyTemplate.successfulMyEvent;
        if (event && typeof event === 'object') {
          eventsApi.sendStatistics({ data, route: location, ...event });
        }
      })
      .catch((error) => {
        const event = isOtherUserBeenPredicted ? storyTemplate.failedOtherEvent : storyTemplate.failedMyEvent;
        if (event && typeof event === 'object') {
          eventsApi.sendStatistics({ data: error, route: location, ...event });
        }
        if (error.error_data.error_reason !== USER_DENIED_ERROR_MESSAGE) {
          throw error;
        }
      });
  };

  return (
    <SharingPopout
      shareStory={shareStory}
      onClose={resetPopout}
    />
  );
};

export default SharingPopoutContainer;
